import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Header from './components/Mobile/Header'
import MobileRoutes from './Routes/MobileRoutes'
import './style.scss'

const tabletQuery = window.matchMedia('(max-width: 991px)')
const desktopQuery = window.matchMedia('(min-width: 992px)')
const isMobileOnly = tabletQuery.matches

const App = () => {
  const [ reset, setReset ] = useState(false)
  const { cartItem } = useSelector((state) => state.login)
  const location = useLocation()
  return (
    <>
      { isMobileOnly ? <MobileRoutes /> : <MobileRoutes /> }
    </>
  )
}

export default App
